module.exports = __webpack_public_path__ + "img/s1.af6741d7.jpg";